import { AgeRangePrice } from "../objects/ageRangePrice";
import { PricingType } from "../objects/pricingType";

// VHT : prix de vente HT
// VTTC : prix de vente HT
// A : prix d'achat
// C : commission en valeure fixe
// M : Markup en valeure fixe
// Com : commission en pourcentage
// Mark : Markup en pourcentage
// TVA: TVA

// Commission en pourcentage du prix de vente (com_calculation_as_percentage)
// Commission s'applique sur le prix de vente TTC (com_applied_on_ttc)
// Commission s'applique sur le prix de vente HT (!com_applied_on_ttc)

export interface PriceUpdateCredential {
    key: string;
    value: string | number;
    pricing_type: PricingType | null;
    com_is_percentage: boolean;
    markup_is_percentage: boolean;
    com_applied_on_ttc: boolean;
    com_calculation_as_percentage: boolean;
    vat: number;
    margin_master_markup: boolean
}


export const updatePriceAgeRange = (_price: AgeRangePrice, price_update_credential: PriceUpdateCredential): AgeRangePrice => {
    const { key, value, pricing_type, com_is_percentage, markup_is_percentage, com_applied_on_ttc, com_calculation_as_percentage, vat, margin_master_markup } = price_update_credential;

    const price = { ..._price };

    if (key === 'price' || key === 'com_price' || key === 'markup_price' || key === 'selling_price') {
        price[key] = value;
        if (key === 'price') {
            price['price_error'] = '';
        }
        const is_selling_ttc = pricing_type?.includes('TTC');

        // - commission et markup en valeur fixe :
        //     - VHT = A + C + M
        // - commission en pourcentage markup en valeur fixe :
        //     - VHT = A + (A * Com /100) + M
        // - markup en pourcentage commission en valeur fixe :
        //     - VHT = A + C + ((A + C) * Mark /100))
        // - commission et markup en pourcentage :
        //     - VHT = A + (A * Com /100) + ((A + (A * Com /100)) * Mark /100))
        if (pricing_type?.includes('PURCHASE') && (pricing_type?.includes('COM') || pricing_type?.includes('MARKUP') || pricing_type?.includes('DETAILED'))) {
            const _key = 'price';
            if (!key.includes('selling')) {
                const com = Number(com_is_percentage ? (Number(price['price']) * Number(price[`com_${_key}`]) / 100) : Number(price[`com_${_key}`]));

                // Calcul du markup selon le mode (markup ou marge)
                let markup = 0;
                if (markup_is_percentage) {
                    if (margin_master_markup) {
                        // Mode MARKUP : selling = (purchase + com) / (1 - taux/100)
                        // donc markup = (purchase + com) / (1 - taux/100) - (purchase + com)
                        markup = (Number(price['price']) + com) / (1 - Number(price[`markup_${_key}`]) / 100) - (Number(price['price']) + com);
                    } else {
                        // Mode MARGE : marge = (purchase + com) * taux/100
                        markup = (Number(price['price']) + com) * Number(price[`markup_${_key}`]) / 100;
                    }
                } else {
                    // Valeur fixe
                    markup = Number(price[`markup_${_key}`]);
                }

                price[`selling_${_key}`] = Number(price['price'])
                    + com
                    + markup;
                price[`selling_price_error`] = '';
            } else {
                // Calcul inverse : depuis prix de vente vers prix d'achat
                if (!(Number(price['price']) === 0)) {
                    const com = com_is_percentage ? Number(price['price']) * Number(price[`com_${_key}`]) / 100 : Number(price[`com_${_key}`]);

                    let markup = 0;
                    if (markup_is_percentage) {
                        if (margin_master_markup) {
                            // Calcul inverse pour MARKUP
                            // selling = (purchase + com) / (1 - taux/100)
                            // => taux = (1 - (purchase + com) / selling) * 100
                            markup = (1 - (Number(price['price']) + com) / Number(price[`selling_${_key}`])) * 100;
                        } else {
                            // Calcul inverse pour MARGE
                            // selling = purchase + com + (purchase + com) * taux/100
                            // => taux = ((selling - purchase - com) / (purchase + com)) * 100
                            markup = ((Number(price[`selling_${_key}`]) - Number(price['price']) - com) * 100) / (Number(price['price']) + com);
                        }
                    } else {
                        // Valeur fixe
                        markup = Number(price[`selling_${_key}`]) - Number(price['price']) - com;
                    }

                    price[`markup_${_key}`] = markup < 0 ? 0 : markup;
                    if (markup < 0) {
                        price[`selling_price_error`] = 'shared.selling-at-a-loss';
                    } else {
                        price[`selling_price_error`] = '';
                    }
                }
            }
        }
        if (pricing_type?.includes('SELLING') && (pricing_type?.includes('COM') || pricing_type?.includes('MARKUP') || pricing_type?.includes('DETAILED'))) {
            if (key.includes('selling') || key.includes('com') || key.includes('markup')) {
                if (key === 'selling_price') {
                    price['selling_price_error'] = '';
                }
                const _key = 'price';
                if (is_selling_ttc) {
                    if (com_applied_on_ttc) {
                        const selling_price_ttc = Number(price[`selling_${_key}`]);
                        const selling_price_ht = Number(price[`selling_${_key}`]) * 100 / (100 + Number(vat));
                        if (com_calculation_as_percentage) {
                            if (markup_is_percentage) {
                                if (margin_master_markup) {
                                    // A = (VHT - (VTTC * Com / 100)) * (1 - Mark / 100)
                                    price['price'] = (selling_price_ht - (selling_price_ttc * Number(price[`com_${_key}`]) / 100)) * (1 - Number(price[`markup_${_key}`]) / 100);
                                } else {
                                    // A = (VHT - (VTTC * Com / 100)) / (1 + Mark / 100)
                                    price['price'] = (selling_price_ht - (selling_price_ttc * Number(price[`com_${_key}`]) / 100)) / (1 + Number(price[`markup_${_key}`]) / 100);
                                }
                            } else {
                                // A = VHT - M - ((VTTC - M) * Com /100)
                                price['price'] = selling_price_ht - Number(price[`markup_${_key}`]) - ((selling_price_ttc - Number(price[`markup_${_key}`])) * Number(price[`com_${_key}`]) / 100);
                            }
                        } else if (com_is_percentage) {
                            if (markup_is_percentage) {
                                if (margin_master_markup) {
                                    // A = (VHT - (VTTC - (VTTC / (1 + Com / 100)) * (1 - Mark /100)
                                    price['price'] = (selling_price_ht - (selling_price_ttc - (selling_price_ttc / (1 + Number(price[`com_${_key}`]) / 100)))) * (1 - Number(price[`markup_${_key}`]) / 100);
                                } else {
                                    // A = (VHT - (VTTC - (VTTC / (1 + Com / 100)) / (1 + Mark /100)
                                    price['price'] = (selling_price_ht - (selling_price_ttc - (selling_price_ttc / (1 + Number(price[`com_${_key}`]) / 100)))) / (1 + Number(price[`markup_${_key}`]) / 100);
                                }
                            } else {
                                // A = VHT - M - (VTTC - (VTTC / (1 + Com) / 100))
                                price['price'] = selling_price_ht - Number(price[`markup_${_key}`]) - (selling_price_ttc - (selling_price_ttc / (1 + Number(price[`com_${_key}`]) / 100)));
                            }
                        } else {
                            if (markup_is_percentage) {
                                if (margin_master_markup) {
                                    // A = (VTTC - C) * (1 - Mark /100)
                                    price['price'] = (Number(price[`selling_${_key}`]) - Number(price[`com_${_key}`])) * (1 - Number(price[`markup_${_key}`]) / 100);
                                } else {
                                    // A = (VTTC - C) / (1 + Mark /100)
                                    price['price'] = (Number(price[`selling_${_key}`]) - Number(price[`com_${_key}`])) / (1 + Number(price[`markup_${_key}`]) / 100);
                                }
                            } else {
                                // A = VHT - C - M
                                price['price'] = selling_price_ht - Number(price[`com_${_key}`]) - Number(price[`markup_${_key}`]);
                            }
                        }
                    } else {
                        const selling_price = Number(price[`selling_${_key}`]) * 100 / (100 + Number(vat));
                        if (com_calculation_as_percentage) {
                            if (markup_is_percentage) {
                                if (margin_master_markup) {
                                    // A = (VHT - (VHT * Com / 100)) * (1 - Mark / 100)
                                    price['price'] = (selling_price - (selling_price * Number(price[`com_${_key}`]) / 100)) * (1 - Number(price[`markup_${_key}`]) / 100);
                                } else {
                                    // A = (VHT - (VHT * Com / 100)) / (1 + Mark / 100)
                                    price['price'] = (selling_price - (selling_price * Number(price[`com_${_key}`]) / 100)) / (1 + Number(price[`markup_${_key}`]) / 100);
                                }
                            } else {
                                // A = VHT - M - ((VHT - M) * Com /100)
                                price['price'] = (selling_price - Number(price[`markup_${_key}`]) - ((selling_price - Number(price[`markup_${_key}`])) * Number(price[`com_${_key}`]) / 100));
                                // price['price'] = (selling_price - Number(price[`markup_${_key}`]) - (selling_price - selling_price * Number(price[`com_${_key}`]) / 100))
                            }
                        } else if (com_is_percentage) {
                            if (markup_is_percentage) {
                                if (margin_master_markup) {
                                    // A = VHT / (1 + Com / 100)) * (1 - Mark /100)
                                    price['price'] = selling_price / (1 + Number(price[`com_${_key}`]) / 100) * (1 - Number(price[`markup_${_key}`]) / 100);
                                } else {
                                    // A = VHT / (1 + Com / 100)) / (1 + Mark /100)
                                    price['price'] = selling_price / (1 + Number(price[`com_${_key}`]) / 100) / (1 + Number(price[`markup_${_key}`]) / 100);
                                }
                            } else {
                                // A = (VHT - M) / ((1 + Com) / 100))
                                price['price'] = (selling_price - Number(price[`markup_${_key}`])) / (1 + Number(price[`com_${_key}`]) / 100);
                            }
                        } else {
                            if (markup_is_percentage) {
                                if (margin_master_markup) {
                                    // A = (VTTC - C) * (1 - Mark /100)
                                    price['price'] = (Number(price[`selling_${_key}`]) - Number(price[`com_${_key}`])) * (1 - Number(price[`markup_${_key}`]) / 100);
                                } else {
                                    // A = (VTTC - C) / (1 + Mark /100)
                                    price['price'] = (Number(price[`selling_${_key}`]) - Number(price[`com_${_key}`])) / (1 + Number(price[`markup_${_key}`]) / 100);
                                }
                            } else {
                                // A = VHT - C - M
                                price['price'] = selling_price - Number(price[`com_${_key}`]) - Number(price[`markup_${_key}`]);
                            }
                        }
                    }
                } else {
                    if (com_calculation_as_percentage) {
                        if (markup_is_percentage) {
                            if (markup_is_percentage) {
                                // A = (VHT - (VHT * Com / 100)) * (1 - Mark / 100)
                                price['price'] = (Number(price[`selling_${_key}`]) - (Number(price[`selling_${_key}`]) * Number(price[`com_${_key}`]) / 100)) * (1 - Number(price[`markup_${_key}`]) / 100);
                            } else {
                                // A = (VHT - (VHT * Com / 100)) / (1 + Mark / 100)
                                price['price'] = (Number(price[`selling_${_key}`]) - (Number(price[`selling_${_key}`]) * Number(price[`com_${_key}`]) / 100)) / (1 + Number(price[`markup_${_key}`]) / 100);
                            }
                        } else {
                            // A = VHT - M - ((VHT - M) * Com /100)
                            price['price'] = (Number(price[`selling_${_key}`]) - Number(price[`markup_${_key}`])) - ((Number(price[`selling_${_key}`]) - Number(price[`markup_${_key}`])) * Number(price[`com_${_key}`]) / 100);
                        }
                    } else if (com_is_percentage) {
                        if (markup_is_percentage) {
                            if (markup_is_percentage) {
                                // A = VHT / (1 + Com / 100)) * (1 - Mark /100)
                                price['price'] = Number(price[`selling_${_key}`]) / (1 + Number(price[`com_${_key}`]) / 100) * (1 - Number(price[`markup_${_key}`]) / 100);
                            } else {
                                // A = VHT / (1 + Com / 100)) / (1 + Mark /100)
                                price['price'] = Number(price[`selling_${_key}`]) / (1 + Number(price[`com_${_key}`]) / 100) / (1 + Number(price[`markup_${_key}`]) / 100);
                            }
                        } else {
                            // A = (VHT - M) / ((1 + Com) / 100))
                            price['price'] = (Number(price[`selling_${_key}`]) - Number(price[`markup_${_key}`])) / (1 + Number(price[`com_${_key}`]) / 100);
                        }
                    } else {
                        if (markup_is_percentage) {
                            if (markup_is_percentage) {
                                // A = (VTTC - C) * (1 - Mark /100)
                                price['price'] = (Number(price[`selling_${_key}`]) - Number(price[`com_${_key}`])) * (1 - Number(price[`markup_${_key}`]) / 100);
                            } else {
                                // A = (VTTC - C) / (1 + Mark /100)
                                price['price'] = (Number(price[`selling_${_key}`]) - Number(price[`com_${_key}`])) / (1 + Number(price[`markup_${_key}`]) / 100);
                            }
                            // price['price'] = (Number(price[`selling_${_key}`]) - Number(price[`com_${_key}`]) - Number(price[`com_${_key}`]) * Number(price[`markup_${_key}`]) / 100) * 100 / (100 + Number(price[`markup_${_key}`]))
                        } else {
                            // A = VHT - C - M
                            price['price'] = Number(price[`selling_${_key}`]) - Number(price[`com_${_key}`]) - Number(price[`markup_${_key}`]);
                        }
                    }
                }
            }
        }
        for (const prop in price) {
            if ((prop === 'price' || prop === 'com_price' || prop === 'markup_price' || prop === 'selling_price') && typeof price[prop] === 'number') {
                price[prop] = Number(price[prop]).toFixed(2);
            }
        }

        return price;
    } else {
        return price;
    }


};
